var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"light":"","absolute":""}},[_c('div',{staticClass:"footer"},[_vm._v(" esPAYcrow test 2020. All right reserved ")])])}
var staticRenderFns = []

export { render, staticRenderFns }